import { ApiService } from "../../../../../core";
import { DashboardController, DashboardRequestResponse } from "../../core/controllers/adm/DashboardController";

export class DashboardControllerImpl implements DashboardController {
    private api;
    constructor() {
        this.api = new ApiService(process.env.REACT_APP_API)
    }
    async onLoad(): Promise<DashboardRequestResponse> {
        try {
            const responseJson: DashboardRequestResponse = await this.api.get('/adm-dashboard-page');
            return responseJson;
        } catch (error) {
            if (error?.response?.status === 401 || error?.response?.status === 403) {
                throw (error?.response?.status.toString());
            } else {
                throw new Error("Falha ao requisitar os dados para o Dashboard");
            }
        }
    }
}